module.exports = "/_next/static/images/error-8228f5360a3206d10460f59e05b315dd.png";